module.exports = __webpack_public_path__ + "selwebee_spt_game-ENGLISH-6bd1df7cd44af3000126a6ce08c1e0f8.png";